import { useEffect, useState } from 'react';

import { ReactComponent as Downarrow } from '../../../assets/icons/down-arrow.svg';
import { ReactComponent as LocationIcon } from '../../../assets/icons/location-icon.svg';
import DefaultApiLimit from '../../../config/defaultLimit';
import {
  AvailableMaintenance,
  // FilterScheduleInterFace,
  RequestScheduleInterFace,
} from '../../../interface/maintenance-scheduling.interface';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import {
  disableMaintenanceManagementFiltersApplied,
  fetchAllMaintenanceSchedules,
  fetchMaintenanceManagementListFilters,
  setScheduleFilterData,
  updateMaintenanceManagementFilters,
  setSortData,
} from '../../../redux/slice/MaintenanceScheduleManagementSlice';
import { setNotificationDetails } from '../../../redux/slice/NotificationSlice';
import { RootState } from '../../../redux/store';
import CustomTable from '../../../shared-components/custom-table/CustomTable';
import DropDownArrow from '../../../shared-components/drop-down-menu/DropDownMenu';
import ExportButton from '../../../shared-components/export-button/ExportButton';
import ModalBox from '../../../shared-components/modal-box/ModalBox';
import SuccessNotification from '../../../shared-components/success-notification/SuccessNotificaion';
import StationSidePanel from '../../../shared-components/table-side-panel/StationSidePanel';
import { GetParametersFromCommonFilters } from '../../../shared-functions/CommonFilters';
import ConvertUTCtoDate from '../../../shared-functions/ConvertUTCtoDate';
import ConvertUTCtoHHMM from '../../../shared-functions/ConvertUTCtoHHMM';
import { exportCSV, exportPDF } from '../../../shared-functions/ExportFile';
import { FormatUtcString } from '../../../shared-functions/FormatUtcString';
import maintenanceScheduleApi from '../../../utils/api/maintenance-schedule';

// import MaintenanceFilter from './MaintenanceFilter';

interface ModalBoxDetail {
  title: string | null;
  content: JSX.Element | null;
  notificationModal: boolean;
  header: boolean;
}

/**
 * Management management page
 */
function MaintenanceManagement() {
  const dispatch = useAppDispatch();
  const { schedules, page, limit, totalPages, totalResults, loading, filter, filters, filterListLoading, isFilterUpdated } =
    useAppSelector((states) => states.maintenanceSchedule);
  const [modalBoxStatus, setModalBoxStatus] = useState<'open' | 'close'>('close');
  const [modalBoxDetail, setModalBoxDetails] = useState<ModalBoxDetail>({
    title: '',
    content: null,
    notificationModal: false,
    header: false,
  });
  const [exportLoader, setExportLoader] = useState<boolean>(false);
  const { sortBy, sortField } = useAppSelector((state: RootState) => state.maintenanceSchedule);

  /**
   * Fetch the date for using redux function
   * @param data
   */
  const fetchData = (data: RequestScheduleInterFace) => {
    if (!loading) {
      dispatch(fetchAllMaintenanceSchedules(data));
    }
  };
  /**
   * Handle status change
   * @param rowId
   * @param newStatus
   */
  const handleStatusChange = (rowId: string | number | null, newStatus: string) => {
    maintenanceScheduleApi
      .editMaintenanceSchedule(rowId, { status: newStatus })
      .then(() => {
        setModalBoxStatus('open');
        setModalBoxDetails({
          title: '',
          header: false,
          content: (
            <SuccessNotification
              title="Status Updated Successfully... "
              description=""
              notificationCloseTimer={3000}
              onNotificationClose={() => {
                fetchData({
                  page,
                  limit,
                });
                setModalBoxStatus('close');
              }}
            />
          ),
          notificationModal: true,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  /**
   * handlePageChange
   */
  const handlePageChange = (pageCount: number) => {
    const queryParameters = GetParametersFromCommonFilters(filters);
    fetchData({
      ...queryParameters,
      sortField,
      sortBy,
      page: pageCount,
      limit,
    });
  };
  /**
   * handleLimitChange
   */
  const handleLimitChange = (limitCount: number) => {
    fetchData({
      ...filter,
      page: DefaultApiLimit.page,
      limit: limitCount,
    });
  };
  // /**
  //  * Handle the filter submit function
  //  */
  // const handleSubmitFilter = (filterData: FilterScheduleInterFace) => {
  //   dispatch(setScheduleFilterData(filterData));
  //   fetchData({
  //     page: DefaultApiLimit.page,
  //     limit,
  //     ...filterData,
  //   });
  //   setModalBoxStatus('close');
  // };

  // /**
  //  * Handle the filter data clear function
  //  */
  // const filterClearFunction = () => {
  //   if (Object.keys(filter).length > 0) {
  //     dispatch(setScheduleFilterData({}));
  //     fetchData({
  //       page: DefaultApiLimit.page,
  //       limit,
  //     });
  //   }
  // };

  /**
   *  Handle the filter data clear function
   * @param filterData
   */
  const handleSortFunction = (sortData: any) => {
    const queryParameters = GetParametersFromCommonFilters(filters);
    dispatch(
      setScheduleFilterData({
        ...sortData,
      }),
    );
    dispatch(setSortData(sortData));
    fetchData({
      ...queryParameters,
      sortBy: sortData.sortBy,
      sortField: sortData.sortField,
      page: DefaultApiLimit.page,
      limit,
    });
  };

  // /**
  //  * filter function
  //  */
  // const FilterModal = () => {
  //   setModalBoxStatus('open');
  //   setModalBoxDetails({
  //     title: '',
  //     header: false,
  //     notificationModal: false,
  //     content: (
  //       <MaintenanceFilter
  //         handleCancel={() => setModalBoxStatus('close')}
  //         handleSubmitFilter={handleSubmitFilter}
  //       />
  //     ),
  //   });
  // };

  /**
   * createDropdownList
   */
  const createDropdownList = (maintenanceId: number | string | null) => [
    {
      value: '1', // Changed from 'id' to 'value'
      content: <p style={{ color: 'orange' }}>In Progress</p>,
      key: 'inProgress',
      /**
       * createDropdownList
       */
      onClickFunc: () => handleStatusChange(maintenanceId, 'inProgress'),
    },
    {
      value: '2', // Changed from 'id' to 'value'
      content: <p style={{ color: 'green' }}>Completed</p>,
      key: 'completed',
      /**
       * createDropdownList
       */
      onClickFunc: () => handleStatusChange(maintenanceId, 'completed'),
    },
    {
      value: '3', // Changed from 'id' to 'value'
      content: <p style={{ color: 'red' }}>Postponed</p>,
      key: 'postponed',
      /**
       * createDropdownList
       */
      onClickFunc: () => handleStatusChange(maintenanceId, 'postponed'),
    },
  ];

  /**
   * Renders the custom data for the serial number column
   * @param {AvailableDevice} device - The device data
   * @param {number} index - The current row index
   * @returns {JSX.Element} The rendered serial number cell
   */
  const renderSerialNumber = (device: AvailableMaintenance, index: number) => (
    <div className="table-row-each-data">{index + 1}</div>
  );

  const column = [
    {
      label: 'S. No',
      customData: renderSerialNumber,
      columnWidth: 40,
      accessorKey: 'sno' as keyof AvailableMaintenance,
    },
    {
      label: 'Maintenance Date',
      accessorKey: 'date' as keyof AvailableMaintenance,
      sortAllow: true,
    },
    {
      label: 'Maintenance Time',
      accessorKey: 'time' as keyof AvailableMaintenance,
      sortAllow: true,
    },
    {
      label: 'Station Name',
      accessorKey: 'name' as keyof AvailableMaintenance,
      sortAllow: true,

      queryParamsKey: 'stationId',
      queryParamsValue: 'chargingStation',
      sidePanelComponent: <StationSidePanel fetchIdFrom="queryParams" />,
    },
    {
      label: 'Station Location',
      accessorKey: 'stationLocation' as keyof AvailableMaintenance,
      sortAllow: true,
      /**
       * maintenance
       */
      customData: (maintenance: AvailableMaintenance) => (
        <div className="location-in-maintenance-table">
          <span>
            <LocationIcon />
          </span>
          <p className="table-row-each-data">{maintenance.address}</p>
        </div>
      ),
    },
    {
      label: 'Task',
      accessorKey: 'type' as keyof AvailableMaintenance,
      sortAllow: true,
    },
    {
      label: 'Duration',
      accessorKey: 'duration' as keyof AvailableMaintenance,
      sortAllow: true,
    },
    {
      label: 'Status',
      accessorKey: 'status' as keyof AvailableMaintenance,
      /**
       * maintenance
       */
      customData: (maintenance: AvailableMaintenance) => (
        <div className="status-wrapper-dropdown">
          {createDropdownList(maintenance.id).find((value) => value.key === maintenance.status)
            ?.content || maintenance.status}
          <DropDownArrow
            rowId={maintenance.id?.toString() || ''} // Convert id to string
            dropDownIcon={<Downarrow />}
            dropDownList={createDropdownList(maintenance.id)}
            lineBetweenElement
          />
        </div>
      ),
    },
  ];

  /**
   * Export data function
   */
  const exportDataPdfOrCSV = (type: string) => {
    setExportLoader(true);
    maintenanceScheduleApi
      .fetchMaintenanceScheduleExport({ ...filter })
      .then((response) => {
        // Convert data to CSV format
        const headers = [
          'Maintenance Date',
          'Maintenance Time',
          'Station Name',
          'Station Location',
          'Task',
          'Duration',
          'Status',
        ];
        const rows = response.data.results.map((row: AvailableMaintenance) => [
          row.startDateUtc ? ConvertUTCtoDate(row.startDateUtc) : '',
          row.startDateUtc ? FormatUtcString(ConvertUTCtoHHMM(row.startDateUtc)) : '',
          row.chargingStationName || '',
          row.chargingStationAddress || '',
          row.type || '',
          row.duration || '0',
          row.status || '',
        ]);
        setExportLoader(false);
        if (rows.length > 0) {
          if (type === 'csv') {
            exportCSV(headers, rows, 'maintenance-schedule-list.csv');
          } else {
            exportPDF(headers, rows, 'maintenance-schedule-list.pdf');
          }
        }
      })
      .catch((error) => {
        setExportLoader(false);
        dispatch(
          setNotificationDetails({
            type: 'error',
            notificationDetails: {
              statusCode: error?.response?.data?.code || 404,
              message: error?.response?.data?.message || 'Something went wrong!',
            },
          }),
        );
      });
  };

  useEffect(() => {
    if (isFilterUpdated || schedules.length === 0) {
      const queryParameters = GetParametersFromCommonFilters(filters);

      fetchData({
        ...queryParameters,
        page: DefaultApiLimit.page,
        limit: DefaultApiLimit.limit,
      });

      dispatch(
        fetchAllMaintenanceSchedules({
          ...queryParameters,
          page,
          limit,
        }),
      );

      dispatch(disableMaintenanceManagementFiltersApplied());
    }
  }, [filters]);

  return (
    <div className="maintenance-management-wrap">
      <ModalBox
        open={modalBoxStatus === 'open'}
        title={modalBoxDetail.title}
        content={modalBoxDetail.content}
        closeModal={() => setModalBoxStatus('close')}
        modalBoxAnimation="modalAnimateToLeft"
        notification={modalBoxDetail.notificationModal}
        header={modalBoxDetail.header}
      />
      <div className="table-container">
        <CustomTable
          paginate
          loading={loading}
          limit={limit}
          header={column}
          data={schedules}
          currentPage={page}
          totalPages={totalPages}
          totalResults={totalResults}
          sortData={{
            sortBy,
            sortField,
          }}
          handleSortChange={handleSortFunction}
          topHeader={false}
          filters={filters}
          filtersToDispatch={updateMaintenanceManagementFilters}
          filterListLoading={filterListLoading}
          filterListToDispatch={fetchMaintenanceManagementListFilters}
          // filterFunction={FilterModal}
          // filterClearFunction={filterClearFunction}
          handlePageChange={handlePageChange}
          handleLimitChange={handleLimitChange}
          footerLeft={
            <div className="table-bottom-button-list">
              <div className="table-button-item">
                <ExportButton
                  label="Export Data"
                  buttonList={[
                    {
                      key: 'pdf',
                      allow: true,
                      /**
                       * Export pdf function
                       * @returns
                       */
                      onClickFunction: () => exportDataPdfOrCSV('pdf'),
                    },
                    {
                      key: 'csv',
                      allow: true,
                      /**
                       * Export csv function
                       * @returns
                       */
                      onClickFunction: () => exportDataPdfOrCSV('csv'),
                    },
                  ]}
                  disabled={schedules.length === 0}
                  loader={exportLoader}
                />
              </div>
            </div>
          }
        />
      </div>
    </div>
  );
}

export default MaintenanceManagement;
